/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";

import MessageItem, {
  MessageItemLoading,
} from "../../components/HelpCenter/MessageItem";

import AddTicket from "../../components/HelpCenter/AddTicket";
import TicketsHeader from "../../components/HelpCenter/TicketsHeader";
import TicketsList from "../../components/HelpCenter/TicketsList";

export default function HelpCenter() {
  const navigate = useNavigate();
  const [searchChatItems, setSearchChatItems] = useState("");
  const [chatItems, setChatItems] = useState([]);
  const [activeChat, setActiveChat] = useState({
    ticket_id: "",
    info: {
      title: "",
      category: "",
      messages: [],
    },
    message: "",
    attachment: null,
  });
  const [gettingMessages, setGettingMessages] = useState(false);
  const [addTicketStatus, setAddTicketStatus] = useState(false);
  const [openMessagesAside, setOpenMessagesAside] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isReplying, setIsReplying] = useState(false);
  const messagesEndRef = useRef(null);

  useEffect(() => {
    if (messagesEndRef) {
      messagesEndRef.current?.addEventListener("DOMNodeInserted", (event) => {
        const { currentTarget: target } = event;
        target.scroll({ top: target.scrollHeight });
      });
    }
  }, []);

  useEffect(() => {
    setLoading(true);

    axios
      .get("support-tickets/get-list")
      .then(({ data }) => {
        setChatItems(data.data);
        setLoading(false);
      })
      .catch(({ response }) => {
        setChatItems([]);
        toast.error(response.data.message);
        response.status === 401 && navigate("/login");
      });

    return () => {
      setChatItems([]);
    };
  }, []);

  useEffect(() => {
    if (activeChat.ticket_id) {
      setGettingMessages(true);

      axios
        .get(
          `support-tickets/get-ticket-messages?ticket_id=${activeChat.ticket_id}`
        )
        .then(({ data }) => {
          setActiveChat({
            ...activeChat,
            info: data.data,
          });
          setGettingMessages(false);
        });
    }
  }, [activeChat.ticket_id]);

  const schema = yup.object().shape({
    message: yup.string().required("Message is required"),
    attachment: yup
      .mixed()
      .test("fileSize", "File size is too big", (value) => {
        if (value) {
          return value.size < 5242880;
        }
        return true;
      })
      .test("fileType", "File type is not supported", (value) => {
        if (value) {
          return (
            value.type === "image/jpeg" ||
            value.type === "image/png" ||
            value.type === "image/jpg"
          );
        }
        return true;
      })
      .nullable(),
  });

  const handleReply = (event) => {
    event.preventDefault();
    setIsReplying(true);

    const formData = new FormData();
    formData.append("ticket_id", activeChat.ticket_id);
    formData.append("message", activeChat.message);
    if (activeChat.attachment) {
      formData.append("attachment", activeChat.attachment);
    }

    schema
      .validate({
        message: activeChat.message,
        attachment: activeChat.attachment,
      })
      .then(() => {
        axios
          .post("support-tickets/reply", formData)
          .then(({ data }) => {
            setIsReplying(false);
            setActiveChat({
              ...activeChat,
              info: {
                ...activeChat.info,
                messages: [
                  ...activeChat.info.messages,
                  {
                    ...data.data.message,
                    isMine: true,
                  },
                ],
              },
              message: "",
              attachment: null,
            });
          })
          .catch(() => {
            setIsReplying(false);
          });
      })
      .catch((err) => {
        toast.error(err.message);
        setIsReplying(false);
      });
  };

  return (
    <div
      className="content d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      {addTicketStatus && (
        <AddTicket
          setChatItems={setChatItems}
          chatItems={chatItems}
          addTicketStatus={addTicketStatus}
          setAddTicketStatus={setAddTicketStatus}
          activeChat={activeChat}
          setActiveChat={setActiveChat}
        />
      )}

      <div className="d-flex flex-column-fluid w-100">
        <div className=" container ">
          <div className="d-flex flex-row">
            <div
              className={`flex-row-auto offcanvas-mobile w-350px w-xl-400px ${
                openMessagesAside ? "offcanvas-mobile-on" : ""
              }`}
              id="kt_chat_aside"
              style={
                openMessagesAside
                  ? {
                      borderRadius: "0 8px 8px 0",
                      overflow: "hidden",
                    }
                  : {}
              }
            >
              <div
                className="card card-custom"
                style={
                  openMessagesAside
                    ? { height: "100%", borderRadius: "0", border: 0 }
                    : {}
                }
              >
                <div className="card-body">
                  <TicketsHeader
                    addTicketStatus={addTicketStatus}
                    setAddTicketStatus={setAddTicketStatus}
                    searchChatItems={searchChatItems}
                    setSearchChatItems={setSearchChatItems}
                  />
                  <TicketsList
                    chatItems={chatItems}
                    setChatItems={setChatItems}
                    searchChatItems={searchChatItems}
                    activeChat={activeChat}
                    setActiveChat={setActiveChat}
                    loading={loading}
                  />
                </div>
              </div>
            </div>
            {openMessagesAside && (
              <div
                className="offcanvas-mobile-overlay"
                onClick={() => setOpenMessagesAside(false)}
              ></div>
            )}
            <div className="flex-row-fluid ml-lg-8" id="kt_chat_content">
              <div className="card card-custom" style={{ height: "100%" }}>
                <div className="card-header align-items-center px-4 py-3">
                  <button
                    type="button"
                    className="btn btn-clean mr-5 btn-sm btn-icon btn-icon-md d-lg-none"
                    id="kt_app_chat_toggle"
                    onClick={() => setOpenMessagesAside(true)}
                  >
                    <span className="svg-icon svg-icon-lg">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24px"
                        height="24px"
                        viewBox="0 0 24 24"
                        version="1.1"
                      >
                        <g
                          stroke="none"
                          stroke-width="1"
                          fill="none"
                          fill-rule="evenodd"
                        >
                          <rect x="0" y="0" width="24" height="24"></rect>
                          <path
                            d="M10.5,5 L19.5,5 C20.3284271,5 21,5.67157288 21,6.5 C21,7.32842712 20.3284271,8 19.5,8 L10.5,8 C9.67157288,8 9,7.32842712 9,6.5 C9,5.67157288 9.67157288,5 10.5,5 Z M10.5,10 L19.5,10 C20.3284271,10 21,10.6715729 21,11.5 C21,12.3284271 20.3284271,13 19.5,13 L10.5,13 C9.67157288,13 9,12.3284271 9,11.5 C9,10.6715729 9.67157288,10 10.5,10 Z M10.5,15 L19.5,15 C20.3284271,15 21,15.6715729 21,16.5 C21,17.3284271 20.3284271,18 19.5,18 L10.5,18 C9.67157288,18 9,17.3284271 9,16.5 C9,15.6715729 9.67157288,15 10.5,15 Z"
                            fill="#000000"
                          ></path>
                          <path
                            d="M5.5,8 C4.67157288,8 4,7.32842712 4,6.5 C4,5.67157288 4.67157288,5 5.5,5 C6.32842712,5 7,5.67157288 7,6.5 C7,7.32842712 6.32842712,8 5.5,8 Z M5.5,13 C4.67157288,13 4,12.3284271 4,11.5 C4,10.6715729 4.67157288,10 5.5,10 C6.32842712,10 7,10.6715729 7,11.5 C7,12.3284271 6.32842712,13 5.5,13 Z M5.5,18 C4.67157288,18 4,17.3284271 4,16.5 C4,15.6715729 4.67157288,15 5.5,15 C6.32842712,15 7,15.6715729 7,16.5 C7,17.3284271 6.32842712,18 5.5,18 Z"
                            fill="#000000"
                            opacity="0.3"
                          ></path>
                        </g>
                      </svg>
                    </span>
                  </button>

                  {activeChat.info.title && (
                    <div className="text-left flex-grow-1">
                      <div className="font-weight-bold font-size-h5">
                        {activeChat.info.title}
                      </div>
                    </div>
                  )}

                  {activeChat.info.category && (
                    <div className="text-right flex-grow-1">
                      <span className="label label-lg label-light-primary label-inline font-weight-bold py-4">
                        {activeChat.info.category}
                      </span>
                    </div>
                  )}
                </div>
                <div
                  className={`card-body py-1${
                    activeChat.info.title
                      ? ""
                      : " d-flex justify-content-center align-items-center"
                  }`}
                  style={{ paddingInlineEnd: "1rem", minHeight: "300px" }}
                >
                  <div
                    className="scroll scroll-pull ps ps--active-y"
                    data-mobile-height="350"
                  >
                    <div
                      className="messages"
                      ref={messagesEndRef}
                      style={{
                        maxHeight: "312px",
                        overflow: "auto",
                        paddingInlineEnd: "1rem",
                      }}
                    >
                      {activeChat.info.title ? (
                        gettingMessages ? (
                          <>
                            {Array.from(Array(3).keys()).map((index) => (
                              <MessageItemLoading
                                index={index}
                                isFile={index === 3 || index === 4}
                              />
                            ))}
                          </>
                        ) : (
                          <>
                            {activeChat.info.messages.map((message, index) => (
                              <MessageItem key={index} message={message} />
                            ))}
                          </>
                        )
                      ) : (
                        <div className="text-align-center">
                          <h3>
                            Create a ticket to start chatting or select a ticket
                          </h3>
                          <br />
                          <button
                            className="btn btn-primary-custom"
                            onClick={() => setAddTicketStatus(!addTicketStatus)}
                          >
                            Create Ticket
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                {activeChat.info.title && (
                  <div className="card-footer align-items-center">
                    <textarea
                      className="form-control border-0 "
                      rows="2"
                      placeholder="Type a message"
                      value={activeChat.message}
                      onChange={(event) =>
                        setActiveChat({
                          ...activeChat,
                          message: event.target.value,
                        })
                      }
                      style={{ maxHeight: "100px", minHeight: "50px" }}
                    ></textarea>
                    <div className="d-flex align-items-center justify-content-between mt-5">
                      <label htmlFor="send-file">
                        <div className="btn btn-clean btn-icon btn-md mr-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            version="1.1"
                          >
                            <g
                              stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd"
                            >
                              <rect x="0" y="0" width="24" height="24"></rect>
                              <path
                                d="M14,16 L12,16 L12,12.5 C12,11.6715729 11.3284271,11 10.5,11 C9.67157288,11 9,11.6715729 9,12.5 L9,17.5 C9,19.4329966 10.5670034,21 12.5,21 C14.4329966,21 16,19.4329966 16,17.5 L16,7.5 C16,5.56700338 14.4329966,4 12.5,4 L12,4 C10.3431458,4 9,5.34314575 9,7 L7,7 C7,4.23857625 9.23857625,2 12,2 L12.5,2 C15.5375661,2 18,4.46243388 18,7.5 L18,17.5 C18,20.5375661 15.5375661,23 12.5,23 C9.46243388,23 7,20.5375661 7,17.5 L7,12.5 C7,10.5670034 8.56700338,9 10.5,9 C12.4329966,9 14,10.5670034 14,12.5 L14,16 Z"
                                fill="#000000"
                                fill-rule="nonzero"
                                transform="translate(12.500000, 12.500000) rotate(-315.000000) translate(-12.500000, -12.500000) "
                              ></path>
                            </g>
                          </svg>
                        </div>
                      </label>
                      <input
                        type="file"
                        name="attachment"
                        id="send-file"
                        onChange={(event) => {
                          setActiveChat({
                            ...activeChat,
                            attachment: event.target.files[0],
                          });
                        }}
                        hidden
                      />
                      <div>
                        <button
                          type="button"
                          className={`btn btn-primary-custom chat-send py-2 px-6${
                            !activeChat.message || !activeChat.info.title
                              ? " cursor-default"
                              : ""
                          }`}
                          onClick={activeChat.info.title && handleReply}
                          disabled={
                            !activeChat.message ||
                            !activeChat.info.title ||
                            isReplying
                          }
                        >
                          Send{isReplying ? "ing.." : ""}
                        </button>
                      </div>
                    </div>
                    {activeChat.attachment && (
                      <div
                        className="position-relative mt-5"
                        style={{ width: "100px" }}
                      >
                        <svg
                          onClick={() =>
                            setActiveChat({
                              ...activeChat,
                              attachment: null,
                            })
                          }
                          xmlns="http://www.w3.org/2000/svg"
                          width="25px"
                          height="25px"
                          viewBox="0 0 24 24"
                          version="1.1"
                          style={{
                            position: "absolute",
                            borderRadius: "50%",
                            border: "1px solid red",
                            background: "rgb(113 19 45)",
                            cursor: "pointer",
                            top: "-10px",
                            right: "-10px",
                          }}
                        >
                          <g
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                          >
                            <g
                              transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)"
                              fill="#fff"
                            >
                              <rect
                                x="0"
                                y="7"
                                width="16"
                                height="2"
                                rx="1"
                              ></rect>
                              <rect
                                opacity="0.3"
                                transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000) "
                                x="0"
                                y="7"
                                width="16"
                                height="2"
                                rx="1"
                              ></rect>
                            </g>
                          </g>
                        </svg>
                        <img
                          width="100px"
                          className="rounded-card"
                          src={URL.createObjectURL(activeChat.attachment)}
                          alt="attachment"
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
